// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1XOPi","requiredAsterisk":"Info_requiredAsterisk__1OZ2g"};